export default {
  height:'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: true,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "关联id, 不同业务传不同值",
      prop: "relationId",
      type: "input",
    },
    {
      label: "客户id",
      prop: "loanInformationId",
      type: "input",
    },
    {
      label: "业务类型 1.催收操作 2.行动操作 3.不良资产操作 4.法务操作",
      prop: "businessType",
      type: "input",
    },
    {
      label: "业务操作类型 1.记录 2.业务流转",
      prop: "operatorType",
      type: "input",
    },
    {
      label: "业务状态, 根据不同的业务不同的值",
      prop: "businessStatus",
      type: "input",
    },
    {
      label: "操作日志",
      prop: "remark",
      type: "input",
    },
    {
      label: "由系统生成的业务数据",
      prop: "businessData",
      type: "input",
    },
    {
      label: "日志格式 1.字符串 2.富文本 3.json",
      prop: "remarkType",
      type: "input",
    },
    {
      label: "",
      prop: "tenantId",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建部门",
      prop: "createDept",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "状态 1.待还款 2.部分还款 3.还款完成",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ]
}
